import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { Form, Spinner } from 'react-bootstrap'
import { message } from 'antd'

import AgentForm from './AgentForm'

import { storeAgent } from '../services'
import { handleError } from '../../../helpers'

export default function NewAgentModal({ visible, onClose, reload }) {
	const [loading, setLoading] = useState(false)
	const { handleSubmit, register, formState: { errors } } = useForm()

	const onSubmit = values => {
		setLoading(true)
		storeAgent(values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose} size='md'>
				<ModalHeader toggle={onClose}>Agregar Asesor Virtual Nuevo</ModalHeader>
				<ModalBody>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<AgentForm 
							register={register}
							errors={errors}
						/>
						<Button color="primary" type="submit" disabled={loading}>
							{ loading && <Spinner animation='border' size="sm" className='mr-5' /> }
							Crear Asesor Virtual
						</Button>						
					</Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}